import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";

import { useSelector, useDispatch } from "react-redux";

import { storeEditPdValue } from "../../store/slice/mappingSlice";

const PdSelectSearch = ({
  disablePipedriveValue,
  selectDefaultProperty,
  mappedItem,
}) => {
  const dispatch = useDispatch();

  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [pdEditedValue, setPdEditedValue] = useState("");

  const enableEditing = useSelector((state) => state.mapping.enableEditing);
  const pdProperties = useSelector(
    (state) => state.mapping.pipedrive.pdProperties
  );
  const vatValue = useSelector((state) => state.mapping.vatValue);
  const editVatValue = useSelector((state) => state.mapping.editVatValue);

  const onEditSelectedValue = (pdProperty) => {
    const property = JSON.parse(pdProperty);
    setPdEditedValue(property.name);
    dispatch(storeEditPdValue(property));
  };

  const searchItems = (value) => {
    setSearchInput(value);
    const filteredData = pdProperties.filter((el) => {
      return el.name.toLowerCase().includes(value.toLowerCase());
    });

    setSearchResults(filteredData);
  };

  const disablePDFields = (pdProperty, vatFieldType) => {
    if (vatValue && vatValue.length > 0 && vatValue[1]?.type) {
      if (vatValue[1].type === "varchar") {
        return (
          pdProperty["field_type"] === "text" ||
          pdProperty["field_type"] === "varchar" ||
          pdProperty["field_type"] === "address" ||
          pdProperty["field_type"] === "double" ||
          pdProperty["field_type"] === "int"
        );
      } else if (
        vatValue[1].type === "int" ||
        vatValue[1].type === "number" ||
        vatValue[1].type === "double"
      ) {
        return (
          pdProperty["field_type"] === "text" ||
          pdProperty["field_type"] === "varchar" ||
          pdProperty["field_type"] === "double" ||
          pdProperty["field_type"] === "int"
        );
      } else if (vatValue[1].type === "date") {
        return (
          pdProperty["field_type"] === "text" ||
          pdProperty["field_type"] === "varchar" ||
          pdProperty["field_type"] === "double" ||
          pdProperty["field_type"] === "int"
        );
      }
    } else if (
      editVatValue &&
      editVatValue.length > 0 &&
      editVatValue[1]?.type
    ) {
      if (editVatValue[1].type === "varchar") {
        return (
          pdProperty["field_type"] === "text" ||
          pdProperty["field_type"] === "varchar" ||
          pdProperty["field_type"] === "address" ||
          pdProperty["field_type"] === "double" ||
          pdProperty["field_type"] === "int"
        );
      } else if (
        editVatValue[1].type === "double" ||
        editVatValue[1].type === "number" ||
        editVatValue[1].type === "int"
      ) {
        return (
          pdProperty["field_type"] === "text" ||
          pdProperty["field_type"] === "varchar" ||
          pdProperty["field_type"] === "double" ||
          pdProperty["field_type"] === "int"
        );
      } else if (editVatValue[1].type === "date") {
        return (
          pdProperty["field_type"] === "text" ||
          pdProperty["field_type"] === "varchar" ||
          pdProperty["field_type"] === "double" ||
          pdProperty["field_type"] === "int"
        );
      }
    } else if (vatFieldType && editVatValue && editVatValue.length === 0) {
      if (vatFieldType === "varchar") {
        return (
          pdProperty["field_type"] === "text" ||
          pdProperty["field_type"] === "varchar" ||
          pdProperty["field_type"] === "address" ||
          pdProperty["field_type"] === "double" ||
          pdProperty["field_type"] === "int"
        );
      } else if (
        vatFieldType === "number" ||
        vatFieldType === "double" ||
        vatFieldType === "int"
      ) {
        return (
          pdProperty["field_type"] === "text" ||
          pdProperty["field_type"] === "varchar" ||
          pdProperty["field_type"] === "double" ||
          pdProperty["field_type"] === "int"
        );
      } else if (vatFieldType === "date") {
        return (
          pdProperty["field_type"] === "text" ||
          pdProperty["field_type"] === "varchar" ||
          pdProperty["field_type"] === "double" ||
          pdProperty["field_type"] === "int"
        );
      }
    } else if (pdProperty.type === "enum") {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div>
      {enableEditing && (
        <Dropdown onSelect={onEditSelectedValue}>
          <Dropdown.Toggle
            id="dropdown-basic"
            className="dropdown-button dropdown-select"
          >
            {pdEditedValue === ""
              ? selectDefaultProperty(mappedItem[1]).name === "undefined"
                ? "Select"
                : selectDefaultProperty(mappedItem[1]).name
              : pdEditedValue}
          </Dropdown.Toggle>
          <Dropdown.Menu
            renderOnMount={true}
            popperConfig={{ strategy: "fixed" }}
            className="dropdown-container"
          >
            <div className="p-2 dropdown-search-container">
              <div className="d-flex flex-row dropdown-search-box">
                <span className="my-auto">
                  <FaSearch size={15} className="mx-2 dropdown-search-icon" />
                </span>
                <input
                  type="search"
                  placeholder="search.."
                  className="w-100 dropdown-search"
                  onChange={(e) => searchItems(e.target.value)}
                />
              </div>
            </div>
            <div className="dropdown-items-container">
              {(searchInput.length > 1 ? searchResults : pdProperties)
                .slice()
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((el) => (
                  <Dropdown.Item
                    className={
                      "select-options " +
                      ((disablePipedriveValue(el.key) &&
                        el.key !== selectDefaultProperty(mappedItem[1]).key) ||
                      !disablePDFields(el, mappedItem[1].type)
                        ? "disabled-option "
                        : "")
                    }
                    disabled={
                      (disablePipedriveValue(el.key) &&
                        el.key !== selectDefaultProperty(mappedItem[1]).key) ||
                      !disablePDFields(el, mappedItem[1].type)
                    }
                    selected={
                      el.key === selectDefaultProperty(mappedItem[1]).key
                    }
                    eventKey={JSON.stringify(el)}
                    key={el.key}
                    value={el.key}
                  >
                    {el.name}
                  </Dropdown.Item>
                ))}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
  );
};

export default PdSelectSearch;
